<template>
  <b-row class="hp-authentication-page">
    <left-item />

    <Slide1 v-if="slide == 1" @nextSlide="slide++" />
    <Slide2 
      v-else-if="slide == 2" 
      @nextSlide="register()"  
      @prevSlide="slide--" 
      :errorMessage="errorMessage"
    />
    <Congrats v-else />
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BLink,
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
} from "bootstrap-vue";

import LeftItem from "../LeftItem.vue";
import FooterItem from "../FooterItem.vue";
import Slide1 from "./slide1.vue";
import Slide2 from "./slide2.vue";
import Congrats from "./congrats.vue";
import axios from "axios";
import sha512 from "js-sha512";

export default {
  data() {
    return {
      slide: 1,
      errorMessage: null, 
    }
  },
  components: {
    BRow,
    BCol,
    BButton,
    BLink,
    BForm,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    LeftItem,
    FooterItem,
    Slide1,
    Slide2,
    Congrats,
  },
  methods: {
    register() {
      this.$store.state.register.password = sha512(this.$store.state.register.password);
      
      this.errorMessage = null; 

      axios
        .post(
          `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/auth/`,
          this.$store.state.register,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.$router.push({ path: "/pages/authentication/login" });
        })
        .catch((error) => {
          console.log(error);

          if (
            error.response &&
            error.response.data &&
            error.response.data.error
          ) {
            const errorMessage = error.response.data.error;

            // Игнорим ошибку "send AUTH command first"
            if (errorMessage.includes("send AUTH command first")) {
              this.$router.push({ path: "/pages/authentication/login" });
              return;
            }

            let userMessage = "Пользователь с таким ";

            if (errorMessage.includes("inn")) {
              userMessage += "ИНН ";
            } else if (errorMessage.includes("kpp")) {
              userMessage += "КПП ";
            } else if (errorMessage.includes("org_name")) {
              userMessage += "названием организации ";
            } else if (errorMessage.includes("legal_address")) {
              userMessage += "юридическим адресом ";
            } else if (errorMessage.includes("billing_email")) {
              userMessage += "Email для выставления счетов ";
            } else {
              this.errorMessage = process.env.VUE_APP_USER_REGISTRATION_ERROR;
              this.slide = 2; 
              return; 
            }

            userMessage += "уже существует. Пожалуйста, уточните данные.";
            this.errorMessage = userMessage;
          } else {
            this.errorMessage = process.env.VUE_APP_USER_REGISTRATION_ERROR;
          }

          this.slide = 2; 
        });
    },
  },
};
</script>